import { defineComponent, inject } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import { priceFormatterKey } from "../../../infrastructure/price_formatter";
import OptionsMobileOptions from "../OptionsMobileOptions";
import OptionsMobileAccessories from "../OptionsMobileAccessories";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}
export default defineComponent({
  template: html,
  components: { OptionsMobileOptions, OptionsMobileAccessories },
  emits: ["next"],
  setup(_, {emit}) {
    // Injections
    const { t } = useI18n();
    const priceFormatter = inject(priceFormatterKey);
    const next = () => {
      emit("next");
    }

    return {
      t,
      priceFormatter,
      next,
    };
  },
});
